import { createPortal } from "react-dom";
import { ReactNode, useEffect, useState } from "react";

const ModalPortal = ({ children }: { children: ReactNode }) => {
    const [container, setContainer] = useState<HTMLElement | null>(null);

    useEffect(() => {
        setContainer(document.body);
    }, []);

    return container ? createPortal(children, container) : null;
};

export default ModalPortal;
